<template>
  <div
    id="privilege-information-Redemptions"
    class="form-custom"
  >
    <b-row class="redemptions-form">
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-2"
        >
          <b-card-header>
            <span class="information-header">Coupon Code</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div>
                    <label
                      for="redeem-limit"
                      class=""
                    >
                      Code Type
                    </label>
                    <v-select
                      v-model="formData.couponCodeType"
                      class="redeem-limit-container bg-dropdown"
                      :class="[
                        formData.couponCodeType !== null
                          ? 'redeem-limit-selected'
                          : null,
                        { bypass: isEdit },
                      ]"
                      placeholder="--Select--"
                      required
                      :reduce="option => option.value"
                      :options="privilegeCouponCodeList"
                      :clearable="false"
                    />
                  </div>
                  <div>
                    <b-form-group
                      :label="'CPC Qty Per Issue (per Redeem/Min.= 1)'"
                      label-for="'redeem-min"
                      class="required mt-2"
                    >
                      <b-form-input
                        id="redeem-min"
                        v-model="formData.redeemPerMin"
                        @input="$emit('onNumberInput', $event, 'redeemPerMin')"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import usePrivilegeInformation from '../../hooks/usePrivilegeInformation'

export default {
  components: {
    vSelect,
  },
  props: {
    formData: { type: Object, default: {} },
    isEdit: { type: Boolean, default: false },
  },
  setup(props) {
    const { privilegeCouponCodeList } = usePrivilegeInformation(props)

    return {
      privilegeCouponCodeList,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/privilege-information-redemptions.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
